import { OnInit } from '@angular/core';
import { ManagedClient } from '../../shared/models/managed-client';
import { ClientService } from '../../shared/services/client.service';
import { Location } from "@angular/common";
import { DacConfig } from "../../shared/services/dac-config.service";
import { AssessmentTokenService } from "../../shared/services/assessment-token.service";
import { ReportService } from "../../reports/services/report.service";
import { AlertService } from 'app/shared/services/alert.service';
import { ShoppingService } from 'app/shared/services/shopping.service';
import { AssessmentAssignerService } from '../services/assessment-assigner.service';
import { AssignmentService } from 'app/shared/services/assignment.service';
import { AssignmentSingle } from 'app/shared/models/AssignmentSingle';
import { AssignedLibraryAsset } from 'app/shared/models/AssignedLibraryAsset';
var ClientManageAssignmentsComponent = /** @class */ (function () {
    function ClientManageAssignmentsComponent(_clientService, location, alertService, dacConfig, assessmentTokenService, reportService, shoppingService, assessmentAssignerService, assignmentService) {
        this._clientService = _clientService;
        this.location = location;
        this.alertService = alertService;
        this.dacConfig = dacConfig;
        this.assessmentTokenService = assessmentTokenService;
        this.reportService = reportService;
        this.shoppingService = shoppingService;
        this.assessmentAssignerService = assessmentAssignerService;
        this.assignmentService = assignmentService;
    }
    ClientManageAssignmentsComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(ClientManageAssignmentsComponent.prototype, "assignments", {
        get: function () {
            return this.client.assignments;
        },
        enumerable: true,
        configurable: true
    });
    ClientManageAssignmentsComponent.prototype.addAssessmentsFromBattery = function (group) {
        this.assessmentAssignerService.addAssessmentsFromBattery(this.client, group);
    };
    ClientManageAssignmentsComponent.prototype.addAssessment = function (assessment) {
        this.assessmentAssignerService.addAssessment(this.client, assessment);
    };
    ClientManageAssignmentsComponent.prototype.clearAssignment = function (assignment) {
        var _this = this;
        if (assignment.Type != "LibraryAsset") {
            this.assessmentAssignerService.removeAssessment(this.client, assignment);
        }
        else {
            this.assignmentService.removeClientAssignment(this.client, assignment).then(function () {
                _this.client.removeAssignment(assignment);
                _this._clientService.syncLocalClient(_this.client);
                _this.alertService.success("Assignment removed");
            })
                .catch(function (error) {
                console.error(error);
                _this.alertService.error("Failed to remove assignment", 1500);
            });
        }
    };
    ClientManageAssignmentsComponent.prototype.addAssetAssignment = function (asset) {
        var _this = this;
        if (!asset) {
            console.error("asset was null.  Cannot add");
            return;
        }
        // TODO: stephen this needs to be switched to be the
        // assessments.
        // var assignment = {
        //   assetId: asset.id
        //   ,name: asset.title
        //   ,dateAssigned: new Date()
        // };
        var assignment = new AssignmentSingle();
        assignment.Type = "LibraryAsset";
        assignment.DateAssigned = new Date();
        var assignmentItem = new AssignedLibraryAsset();
        assignmentItem.Name = asset.title;
        assignmentItem.Type = "LibraryAsset";
        assignmentItem.AssetId = asset.id;
        assignment.Items.push(assignmentItem);
        var alertId = this.alertService.info("Adding " + assignment.Name + " to " + this.client.id, 120000);
        this.assignmentService.saveClientAssignment(this.client, assignment)
            .then(function (assignment) {
            _this.client.assignments.push(assignment);
            _this._clientService.syncLocalClient(_this.client);
            _this.alertService.clearAlert(alertId);
            _this.alertService.success("Added " + assignment.Name + " to " + _this.client.id);
        })
            .catch(function (error) {
            _this.alertService.clearAlert(alertId);
            _this.alertService.error("There was an error in adding this item to the client.  Please try again or contact customer support");
            console.error(error);
        });
    };
    ClientManageAssignmentsComponent.prototype.handleBatteryCheckout = function (group) {
        var checkoutSubscription = null;
        var assignerService = this.assessmentAssignerService;
        var tokenService = this.assessmentTokenService;
        var client = this.client;
        checkoutSubscription = this.shoppingService.getCheckoutStatus().subscribe(function (status) {
            if (checkoutSubscription && (status == "ORDER_COMPLETE" || status == "ORDER_CANCELLED")) {
                checkoutSubscription.unsubscribe();
            }
            if (status == "ORDER_COMPLETE") {
                // we will refresh this when we the user's get back to the screen, but we need to add it at the time of purchase
                tokenService.addTokensForGroup(group, 1);
                assignerService.addAssessmentsFromBattery(client, group);
            }
        });
    };
    ClientManageAssignmentsComponent.prototype.handleAssessmentCheckout = function (assessment) {
        var checkoutSubscription = null;
        var assignerService = this.assessmentAssignerService;
        var tokenService = this.assessmentTokenService;
        var client = this.client;
        checkoutSubscription = this.shoppingService.getCheckoutStatus().subscribe(function (status) {
            if (checkoutSubscription && (status == "ORDER_COMPLETE" || status == "ORDER_CANCELLED")) {
                checkoutSubscription.unsubscribe();
            }
            if (status == "ORDER_COMPLETE") {
                // we will refresh this when we the user's get back to the screen, but we need to add it at the time of purchase
                tokenService.addTokens(assessment, 1);
                assignerService.addAssessment(client, assessment);
            }
        });
    };
    return ClientManageAssignmentsComponent;
}());
export { ClientManageAssignmentsComponent };



// WEBPACK FOOTER //
// ./src/app/admin/client-manage-assignments/client-manage-assignments.component.ts.pre-build-optimizer.js